
import { PiniaMapAction, PiniaMapState } from '@@/bits/pinia'
import { postModerationWarningText } from '@@/bits/post_moderation'
import { Component, Getter, Vue, namespace } from '@@/bits/vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { useExpandedPostStore } from '@@/pinia/expanded_post'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePostActionStore } from '@@/pinia/surface_post_action'
import type { Cid, Post } from '@@/types'

@Component({
  components: {
    OzContainedButton,
    OzIcon,
  },
})
export default class SurfacePanelPostExpandedApprovalBanner extends Vue {
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  OzContainedButtonColorScheme = OzContainedButtonColorScheme

  @Getter canIModerate!: boolean
  @PiniaMapState(useExpandedPostStore) expandedPost!: Post
  @PiniaMapAction(useSurfacePostActionStore) confirmModerationRejectPost!: (payload: { postCid: Cid }) => void
  @namespace('post').Action approvePost!: (payload: { postCid: Cid }) => void
  @PiniaMapState(useSurfaceStore) isFrozen!: boolean

  get xContentModerationWarning(): boolean {
    return !!this.expandedPost.moderation_violations && this.expandedPost.moderation_violations.length > 0
  }

  get warningText(): string {
    return postModerationWarningText({
      moderationViolations: this.expandedPost.moderation_violations,
      useLongText: true,
    })
  }
}
